
export class Notificator{
    private root: HTMLElement;
    constructor() {
        const body = document.body;
        let root = body.querySelector('.notificator') as HTMLElement
        if (!root) {
            root = document.createElement('div')
            root.classList.add('notificator')
            body.insertAdjacentElement('beforeend', root)
        }
        this.root = root
    }

    addNotification(text: string, status:string) {
        const notification = document.createElement('div')
        notification.classList.add('notificator__item')
        switch (status) {
            case 'success':
                const icon = document.createElement('span')
                icon.classList.add('notificator__itemIcon')
                icon.innerHTML = `<svg width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.01891 4.17396C2.87426 4.07869 2.7759 3.97151 2.66017 3.8167C2.3998 3.4654 1.02848 2.01255 0.744954 1.9411C0.380426 1.85178 -0.0477494 2.13759 0.00432598 2.59607C0.0621876 3.13196 1.40458 4.3764 2.09313 5.00756C2.64281 5.49581 2.93791 5.95429 3.48759 5.44222C3.63803 5.30528 3.72483 5.25169 3.86948 5.10878L6.79149 2.26859C7.04608 2.00064 7.23124 1.7982 7.51476 1.56598C8.74721 0.553749 7.98344 0 7.56105 0C7.25438 0 6.60633 0.678789 6.35753 0.934824L4.67954 2.54844C4.4886 2.72111 4.3208 2.9176 4.13564 3.10219L3.01891 4.17396Z" fill="white"/></svg>`
                notification.insertAdjacentElement('afterbegin', icon)
                break;
        }
        const notificationText =  document.createElement('span')
        notificationText.classList.add('notificator__itemText')
        notificationText.innerText = text
        notification.insertAdjacentElement('beforeend', notificationText)
        this.root.insertAdjacentElement('beforeend', notification);

        // триггер анимации появления
        requestAnimationFrame(() => {
            notification.classList.add('notificator__item_show');
        });

        setTimeout(() => {
            notification.classList.add('notificator__item_remove')
            setTimeout(() => {
                notification.remove()
            }, 500)
        }, 2000)
    }
}